import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children }) => {
    const { isAuthenticated, isLoading } = useAuth();
    const location = useLocation();

    // Show loading state while checking authentication
    if (isLoading) {
        return (
            <div className="min-h-screen bg-[#020817] flex items-center justify-center">
                <div className="text-center">
                    <div className="inline-block animate-spin rounded-full h-12 w-12 border-4 border-emerald-500 border-t-transparent"></div>
                    <p className="mt-4 text-slate-400">Loading...</p>
                </div>
            </div>
        );
    }

    // Not signed in — bounce to the landing page, but carry the requested URL
    // through so it can prompt for login and return the user here afterwards
    // (e.g. a shared Prop Tool deep link).
    if (!isAuthenticated) {
        const redirectTo = `${location.pathname}${location.search}${location.hash}`;
        return (
            <Navigate
                to="/"
                replace
                state={{ showLogin: true, redirectTo }}
            />
        );
    }

    return children;
};

export default ProtectedRoute;

